module.exports = __webpack_public_path__ + "img/videostar_white.f6cb8c6a.svg";